import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g transform="translate(4 5)" fill="none" fillRule="evenodd">
      <path stroke={color} strokeWidth="2" d="M0 9l7 7 9-9V0H9z" />
      <circle fill={color} cx="11.5" cy="4.5" r="1.5" />
      <path stroke={color} strokeWidth="2" d="M3 7l6 6" />
    </g>
  </svg>
);
